/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { OptionGroupComponent } from './option-group';
export * from './option-group-constants';
export * from './option-group';
export function defineOptionGroupComponent() {
    defineCustomElement(OptionGroupComponent);
}
